import styled from 'styled-components';

export const Content = styled.div`
  margin-left: 80px;
  form {
    margin-bottom: 20px;
  }
`;
export const NewTicketHeader = styled.p`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
`;

export const NewTicketInfo = styled.label`
  font-size: 15px;
  font-weight: normal;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  select {
    margin-left: 15px;
  }
`;

export const AttentionIcon = styled.img`
  width: 50px;
  height: 46px;
  position: absolute;
  left: 30px;
  top: 60px;
`;
